module.exports = __webpack_public_path__ + "static/home-banner-74ca592a9a85a3afcd1fbb28b21be09b.jpg";